import React, { useContext, useEffect, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Button, P } from '@upsolve/ui';

import trackComponentAction from '../analytics/trackComponentAction';
import trackComponentImpression from '../analytics/trackComponentImpression';
import { ButtonLink } from '../analytics/LinksWithOnClick';
import getScreenerUrl from '../Links/getScreenerUrl';
import SCREENER_CTA_TYPES from '../analytics/screenerCtaTypes';
import { BankruptcyTruthsModalContext } from '../overlays/BankruptcyTruthsModal';

const promptTrackingProps = {
  componentName: 'DisabledReadingPrompt',
  componentVersion: 1,
};

/**
 * DisabledReadingPrompt
 * - v0: Full width pop-up with simple question and keep reading button
 * - v1: Added link to bankruptcy myths
 *
 * @component
 * @version 0
 */
const DisabledReadingPrompt = (props) => {
  const [visible, setVisible] = useState(false);
  const { setShowingBankruptcyTruths } = useContext(BankruptcyTruthsModalContext);

  // On Mount
  useEffect(() => {
    const timeLastShown = localStorage.getItem('Upsolve.readingPrompt')
      ? Number(localStorage.getItem('Upsolve.readingPrompt'))
      : null;
    const canShow = !timeLastShown || (new Date().getTime() - (1000 * 60 * 10) > timeLastShown);
    if (props.isAllowedToRender() && canShow) {
      trackComponentImpression(promptTrackingProps);
      localStorage.setItem('Upsolve.readingPrompt', new Date().getTime());
      setVisible(true);
    }
  }, [props.isAllowedToRender()]);

  return visible && (
    <StyledDisabledReadingPrompt>
      <P>Considering bankruptcy? We have a free tool to help you!</P>
      <div className="buttons">
        <ButtonLink
          size="lg"
          href={getScreenerUrl({ cta: SCREENER_CTA_TYPES.DISABLED_READING_PROMPT, contentGroup: props.contentGroup })}
          onClick={() => {
            trackComponentAction({ ...promptTrackingProps, actionId: 'disabledReadingPrompt.screenerNavigation', actionMethod: 'click' })
          }}
        >
          Go to Free Bankruptcy Tool
        </ButtonLink>
        <Button
          size="lg"
          onClick={() => {
            setVisible(false);
            if (props.onClose) props.onClose();
          }}
        >
          Keep Reading
        </Button>
      </div>
      <GlobalStyledDisabledReadingPrompt />
    </StyledDisabledReadingPrompt>
  )
}

const StyledDisabledReadingPrompt = styled.div`
  position: fixed;
  z-index: 100;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 0.5em 1em 6em;
  border-top: 2px solid ${props => props.theme.colors.white[100]};
  background: linear-gradient(0deg, ${props => props.theme.colors.white[500]}, white);
  box-shadow: 0 0 140px -5px rgba(0, 0, 0, 0.5);
  & > p {
    text-align: center;
    font-weight: 500;
    font-size: 18px;
  }
  .buttons {
    width: 400px;
    max-width: 100%;
    margin: 0 auto;
    padding: 0;
    & > a, & > button {
      width: 100%;
      margin-bottom: 0.5em;
      font-size: 18px;
      font-weight: 700;
    }
    & > p {
      text-align: center;
      text-decoration: underline;
      font-size: 18px;
      &:hover {
        cursor: pointer;
      }
    }
  }
`;

const GlobalStyledDisabledReadingPrompt = createGlobalStyle`
  .content-body__container, .article__sidebar {
    filter: blur(4px);
    opacity: 0.7;
    pointer-events: none;
  }
`;

export default DisabledReadingPrompt;
